import { useEffect, useMemo, useState } from 'react'
import { WppGrid, WppProgressIndicator, WppTypography } from '@wppopen/components-library-react'
import type { ILabelProps } from './LoadMoreButton.d'
import styles from './LoadMoreButton.module.scss'

interface ILoadingProps {
  /** The current value of the loading indicator */
  value: number
  /** Variant of the loading indicator ('bar' or 'circle') */
  variant: 'bar' | 'circle'
  /** Labels to display for different loading values */
  labels: ILabelProps[] | string
  /** Additional class name for the component */
  className?: string
}

/**
 * A component displaying a loading indicator with varying value and label options.
 *
 * @returns A component displaying a loading indicator with varying value and label options.
 */
const LoadMoreButton = ({ value, labels, variant, className }: ILoadingProps) => {
  const [currentLabel, setCurrentLabel] = useState<string>()

  const sortedLabel = useMemo(() => {
    if (typeof labels !== 'string') return labels.sort((currentVal, nextVal) => nextVal.value - currentVal.value)
  }, [labels])

  useEffect(() => {
    if (typeof labels === 'string') {
      setCurrentLabel(labels)
    } else {
      const correctLabel = sortedLabel?.find(item => item.value <= value)?.label || labels[0].label
      setCurrentLabel(correctLabel)
    }
  }, [value, sortedLabel, labels])

  return (
    <WppGrid container direction="column" alignItems="center" justifyContent="center" className={className}>
      <WppTypography tag="p" type="s-body">
        {currentLabel}
      </WppTypography>
      <WppProgressIndicator variant={variant} value={value} className={styles.smoothLoading} />
    </WppGrid>
  )
}
export default LoadMoreButton
